import { render } from "./category-template-tab.vue?vue&type=template&id=363a1288&scoped=true"
import script from "./category-template-tab.vue?vue&type=script&lang=js"
export * from "./category-template-tab.vue?vue&type=script&lang=js"

import "./category-template-tab.vue?vue&type=style&index=0&id=363a1288&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363a1288"]])

export default __exports__